import { useNavigate } from "react-router-dom";
import { ReactComponent as BadgeOutline } from "../../../assets/icons/badge-outline.svg";
import { ReactComponent as ArrowRight } from "../../../assets/icons/chevron-left.svg";
import { useUser } from "../../../services/user-context";
import { useXPLimit } from "../utils/useXPLimit";

export function XPLimitBanner() {
    const navigate = useNavigate();
    const { userInfo } = useUser() as any;
    const { data: xpLimits } = useXPLimit(userInfo?.id);
    const isLimitReached = xpLimits?.daily_xp_limit_reached;
    const didSessionToday = (xpLimits?.daily_xp_today ?? 0) > 0;

    const handleGoToPraxisPlay = () => {
        navigate("/praxisplay/role-play");
    }

    if (!xpLimits || (didSessionToday && !isLimitReached)) return null;

    return (
        <div className="border-[#ECECEC] bg-background2 shadow-[0_1px_2px_0_rgba(0,0,0,0.08)] rounded-[10px] py-2 px-3 flex items-center justify-between">
            <div className="flex items-start gap-2">
                <div className="mt-1 bg-orange-100 rounded-[6px] w-6 h-6 flex items-center justify-center">
                    <BadgeOutline />
                </div>
                <div className="flex flex-col">
                    <div className="text-base font-semibold text-black">{isLimitReached ? "Daily XP limit reached" : "Keep your streak going"}</div>
                    <div className="text-base text-black">{isLimitReached ? "You can keep practicing. XP resets tomorrow." : "One session today keeps your streak active."}</div>
                </div>
            </div>
            <div>
                <button onClick={handleGoToPraxisPlay} className="flex items-center gap-0.5 text-PraxisTerracotta text-base font-semibold">Go to PraxisPlay

                    <ArrowRight className="rotate-180 [&_path]:stroke-PraxisTerracotta [&_path]:stroke-[2px]" />
                </button>
            </div>
        </div>
    )
}
